import * as React from 'react';
import { observer } from 'mobx-react';
import { CycleConfigRow } from 'nomst/Components/Configuration/cycleConfigRow';
import { ICycleConfiguration } from 'typings/cycleConfiguration';
import { CycleStatus, ConfigViews } from 'typings/enums';
import { CreateCycleConfigDialog } from 'nomst/Components/Configuration/createCycleConfigDialog';
import { ConfigurationsStore } from 'nomst/Stores/Configuration/configurations.store';
import { Configuration } from 'nomst/Stores/Configuration/configuration';
import './cycleConfigMenu.scss';

export interface ICycleConfigMenuProps {
    cycleConfigs: Configuration[];
    selectedCycleId: number;
    currentView: ConfigViews;
    configurationsStore: ConfigurationsStore;
}

export interface ICycleConfigMenuState {
    showModal: boolean;
}

export class CycleConfigMenu extends React.Component<ICycleConfigMenuProps, ICycleConfigMenuState> {
    constructor(props: ICycleConfigMenuProps) {
        super(props);
        this.handleAddNewCycle = this.handleAddNewCycle.bind(this);
        this.handleModalClose = this.handleModalClose.bind(this);
        this.renderConfigRow = this.renderConfigRow.bind(this);
        this.handleCreateCycleConfirmation = this.handleCreateCycleConfirmation.bind(this);
        this.state = { showModal: false };
    }

    render(): React.ReactNode {
        const { cycleConfigs } = this.props;
        const openCycleConfig = cycleConfigs.find(config => config.status === CycleStatus.Open);
        return (
            <div className="nomst-cycle-config-menu">
                <h3
                    className="nomst-config-menu__heading"
                >
                    Cycle Configuration
                </h3>
                <ul className="nomst-config-menu__items">
                    {openCycleConfig && this.renderConfigRow(openCycleConfig)}
                    {cycleConfigs.filter(config => config.status !== CycleStatus.Open)
                        .map(this.renderConfigRow)}
                </ul>
                <button
                    className="new-cycle-button pxl-link"
                    onClick={this.handleAddNewCycle}
                >
                    <i className="icon-border icon-circle-thin">
                        <i className="icon-plus" />
                    </i>
                    <span>Add a New Cycle</span>
                </button>
                {this.renderCreateCycleConfigDialog()}
            </div>
        );
    }

    private renderConfigRow(cycleConfig: Configuration): React.ReactNode {
        const { selectedCycleId, currentView } = this.props;
        return (
            <CycleConfigRow
                key={cycleConfig.cycleId}
                config={cycleConfig}
                selectedCycleId={selectedCycleId}
                currentView={currentView}
            />
        );
    }

    private renderCreateCycleConfigDialog(): React.ReactNode {
        if (!this.state.showModal) {
            return null;
        }

        return (
            <CreateCycleConfigDialog
                newCycleConfiguration={this.props.configurationsStore.newCycleConfiguration}
                onCancel={this.handleModalClose}
                onClose={this.handleModalClose}
                onConfirm={this.handleCreateCycleConfirmation}
            />
        );
    }

    private handleAddNewCycle(): void {
        this.setState({ showModal: true });
    }

    private handleModalClose(): void {
        this.setState({ showModal: false });
    }

    private async handleCreateCycleConfirmation(cycle: ICycleConfiguration): Promise<void> {
        const { configurationsStore } = this.props;
        await configurationsStore.createCycleConfiguration(cycle);
        this.setState({ showModal: false });
    }
}

export default observer(CycleConfigMenu);